// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PencilScribbleGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m49.256 8.915 3.176 2.827a2.636 2.636 0 0 1 .216 3.718l-2.209 2.48-7.109-6.329 2.209-2.48a2.636 2.636 0 0 1 3.717-.216ZM28.073 28.747 42.35 12.713l7.11 6.33-14.277 16.034-7.109-6.33Zm-1.545 9.863 7.473-2.612-6.706-5.97-1.73 7.725a.737.737 0 0 0 .963.857ZM7.906 43.174c.229.921.732 1.834 1.51 2.738.78.904 1.748 1.456 2.906 1.656 1.158.2 2.42.082 3.783-.355 1.377-.432 2.787-1.158 4.232-2.178 1.45-1.01 2.848-2.287 4.195-3.832l-1.438-1.235c-1.137 1.303-2.308 2.4-3.515 3.29-1.197.886-2.36 1.542-3.491 1.966-1.117.43-2.131.603-3.044.52-.912-.081-1.64-.44-2.184-1.072-.792-.91-1.202-1.842-1.23-2.796-.031-.964.188-1.938.66-2.922a17.788 17.788 0 0 1 1.784-2.962c.728-.995 1.462-1.977 2.202-2.944a26.102 26.102 0 0 0 1.913-2.866c.53-.93.825-1.823.886-2.68.07-.863-.219-1.678-.868-2.446-.46-.523-1.071-.808-1.832-.855-.765-.057-1.62.09-2.566.444-.94.34-1.907.85-2.9 1.532a18.4 18.4 0 0 0-2.862 2.42 18.188 18.188 0 0 0-2.431 3.08c-.185.275-.24.533-.167.773.073.24.213.428.421.563.218.13.45.18.698.15.253-.045.465-.208.636-.489a15.182 15.182 0 0 1 1.854-2.345 20.972 20.972 0 0 1 2.26-2.048 15.55 15.55 0 0 1 2.3-1.503c.742-.4 1.393-.65 1.95-.75.554-.11.95-.026 1.19.254.3.344.422.756.363 1.237-.063.472-.337 1.106-.824 1.903-.486.797-1.221 1.852-2.205 3.167-.578.77-1.16 1.58-1.747 2.434-.59.843-1.11 1.718-1.56 2.623a10.28 10.28 0 0 0-.944 2.742 6.49 6.49 0 0 0 .065 2.786Z"
			fill="url(#PencilScribbleGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="PencilScribbleGradient_tsx__a"
				x1={1.666}
				y1={12.25}
				x2={4.833}
				y2={48.444}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default PencilScribbleGradient;
